import axios from 'axios';
import {
  UPDATE_PRODUCT,
  SEARCH_SCANPACK_ORDER,
  SEARCH_SCANPACK_ORDER_FAIL,
  IMPORT_ORDER_SUCCESS,
  IMPORT_ORDER_FAIL,
  IMPORT_ORDER_STATUS_SUCCESS,
  IMPORT_ORDER_STATUS_FAIL,
  FULL_ORDER_SCAN_CHECK,
  DETECT_ORDERS_DISCREPANCIES,
  DASHBOARD_DATA,
  CHECK_IMPORT_ORDER_STATUS_SUCCESS,
  CHECK_IMPORT_ORDER_STATUS_FAIL,
  RESET_SCANPACK_ORDER,
  OFFLINE_DATA,
  SHOW_DUPLICATE_PICK_WARNING,
  HIDE_DUPLICATE_PICK_WARNING,
  SHOW_DUPLICATE_PICK_TOAST,
  HIDE_DUPLICATE_PICK_TOAST,
  CLEAR_ON_DEMAND_IMPORT_EVENT
} from '../constants';

import AsyncStorage from '@react-native-async-storage/async-storage';
import { extractToteAssignments, handleCartData, setActiveTote, setCartAssignmentDetails, setCartAssignmentToast, setNonAssignmentDetails, setNotFullFilledItems, setPickingSession, setToteAssignments, setPreviousScanInfo, setZoneAccessModalForCart, setShowCartReadyBanner, setCartToastMessage } from './scanToCartActions';
import audioService from '../services/AudioService';
import { navigate } from "../components/root_navigation"
import { normalizeRfoScanToCartInput } from '../components/scanpack/scanBarcodeFunctions';
import { handleIsEmptyCart, handleScanError, handleToteOrderCompletionAndNavigation, navigateToScanPackItem, resumePendingReScan, setCurrentCartScanComplete, setLastCartInput, setMainInputFocus, setPrompt } from './ScanToCartScanningActions';
import { findPendingReScanOrder } from '../components/scanToCartScanning/utils/scanningUtils';
import { setCurrentItem } from './scanpackScanningActions';
import { loadAwaitingWindowPreference } from '../utils/awaitingWindowPreferences';
export function SearchScanpackOrder(data, callBack, isDispatch = false) {
  return async (dispatch, getState) => {
    if (callBack === false && !data.scan_to_cart_enabled) {
      return dispatch({
        type: SEARCH_SCANPACK_ORDER_FAIL,
        payload: ''
      });
    }

    try {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');

      if (data.scan_to_cart_enabled) {
        const userInfo = getState?.()?.user?.userInfo;
        data = {
          ...data,
          awaiting_window_days: loadAwaitingWindowPreference(userInfo)
        };
        if (data.hasOwnProperty('store_order_id')) {
          data = {
            ...data,
            original_input: data.input,
            input: normalizeRfoScanToCartInput(data.input)
          };
        }
      }

      const silenceWarnings = await AsyncStorage.getItem('silenceDuplicatePickWarnings');
      if (silenceWarnings === 'true') {
        data = {
          ...data,
          silence_duplicate_warning: true
        };
      }

      const response = await axios({
        method: 'post',
        url: `${url}/scan_pack/scan_barcode.json`,
        headers: {Authorization: `Bearer ${access_token}`},
        data
      });
      if(response.data?.success_messages?.includes('Order has been reset and is ready for rescanning') && response.data?.data?.previous_scan_timestamp && response.data?.data?.previous_scanner_username) {
        dispatch(setPreviousScanInfo({
          timestamp: response.data?.data?.previous_scan_timestamp,
          username: response.data?.data?.previous_scanner_username
        }));
        dispatch(setCartAssignmentToast(true));
      }
      if(response.data?.success_messages?.includes('Duplicate pick warning')) {
        dispatch({
          type: SHOW_DUPLICATE_PICK_WARNING,
          payload: data
        });
        return;
      }
      if(response.data?.success_messages?.includes('Duplicate pick activity log added')) {
        dispatch({
          type: SHOW_DUPLICATE_PICK_TOAST
        });
        return;
      }
      if (data.scan_to_cart_enabled && !response.data?.data?.next_state) {
        handleScanToCart(data, response, dispatch, callBack);
        return;
      }
      if (data.scan_to_cart_enabled && response.data?.data?.next_state) {
        if (!data.hasOwnProperty('store_order_id')) {
          await handleScanError(dispatch);
        }
      }

      dispatch({
        type: SEARCH_SCANPACK_ORDER,
        payload: response?.data
      });
      if(isDispatch && callBack) {
        dispatch(callBack(response?.data?.data?.order[0]?.scan_hash?.data?.order));
        dispatch(setCurrentItem());
        return;
      }
      if(callBack) callBack();
    } catch (error) {
      if (error?.response?.status) {
        dispatch({
          type: SEARCH_SCANPACK_ORDER_FAIL,
          payload: error?.response?.status
        });
      }
      if(callBack) callBack();
    }
  };
}
const ORDER_REMOVED_FROM_CART = 'order_removed_from_cart';
const ORDER_REMOVED_FALLBACK_MESSAGE = 'This order was removed from the cart. Put its items aside.';

function removedOrdersMessage(removedOrders) {
  return removedOrders
    .map(({increment_id, status, tote_id}) => {
      const state = status ? ` (${status})` : '';
      const tote = tote_id ? ` Take its items out of tote ${tote_id} and set them aside.` : '';
      return `Order ${increment_id} was removed from this cart${state}.${tote}`;
    })
    .join(' ');
}

function showRemovedFromCartToast(dispatch, message) {
  dispatch(setCartToastMessage(message, {severity: 'error', sticky: true}));
  dispatch(setCartAssignmentToast(true));
}

function handleScanToCart(data, response, dispatch, callBack) {
  const removedOrders = response.data?.data?.removed_orders;
  const hasRemovedOrders = Array.isArray(removedOrders) && removedOrders.length > 0;

  if (response.data?.error_code === ORDER_REMOVED_FROM_CART) {
    showRemovedFromCartToast(
      dispatch,
      response.data.error_messages?.[0] || (hasRemovedOrders ? removedOrdersMessage(removedOrders) : ORDER_REMOVED_FALLBACK_MESSAGE)
    );
    audioService.playErrorSound();
    if (callBack) callBack();
    return;
  }

  if (hasRemovedOrders) {
    showRemovedFromCartToast(dispatch, removedOrdersMessage(removedOrders));
  }

  if (
    !response.data.status &&
    response.data.error_messages.includes('No orders available to assign')
  ) {
    dispatch(setCartAssignmentToast(true));
    dispatch(setNonAssignmentDetails(response.data));
    callBack();
    return;
  }

  if (
    !response.data.status &&
    response.data.error_messages &&
    response.data.error_messages.includes('Please specify the zone access for the cart')
  ) {
    if (response.data.data?.cart) {
      dispatch(setZoneAccessModalForCart({
        visible: true,
        cartId: response.data.data?.cart.id,
        cartName: response.data.data?.cart.cart_name,
        scanBarcodePayload: data
      }));
    }
    callBack();
    return;
  }

  if (
    !response.data.status &&
    response.data.data.cart &&
    data.cart_action === 'take_assignment'
  ) {
    dispatch(handleCartData(response.data.data?.cart[0]));
    callBack();
    navigate('ScanToCart');
    return;
  }

  if(response.data.data?.cart &&
    response.data.success_messages &&
    Array.isArray(response.data.success_messages) &&
    response.data.success_messages.includes('Orders successfully assigned to you'))
    {
      dispatch(handleCartData(response.data.data?.cart[0]));
      if (data.cart_action === 'take_assignment') {
        dispatch(setShowCartReadyBanner(true));
      }
      callBack();
      navigate('ScanToCart');
      return;
    }

  if (
    !response.data.status &&
    response.data.error_messages[0].includes('User already has a cart (ID:')
  ) {
    const error = response.data.error_messages[0].replace(/\bUser\b/, "You").replace(/\bhas\b/, "have");
    dispatch(setPickingSession({isInProgress: true, data: response.data?.data?.cart, errorMessage:error}));
    callBack();
    return;
  }

  if(response.data?.message?.includes('has been reset for re-scanning')){
    const order = response.data?.order || response.data?.data?.order;
    dispatch(setToteAssignments(extractToteAssignments(response.data?.cart)))
    if(order) {
      const postScanningParams = data._postScanningParams || null;
      setTimeout(() => {
        dispatch(navigateToScanPackItem(order, postScanningParams));
      }, 100);
    }
    if(callBack) callBack();
    return;
  }

  if (
    !response.data.status &&
    response.data.error_messages[0].includes('User already has a cart')
  ) {
    dispatch(setPickingSession({isInProgress: true, data: response.data?.data?.cart}));
    callBack();
    return;
  }

  if (response.data?.message?.includes('Out of stock items found')) {
    dispatch(handleCartData(response.data.cart));
    dispatch(setPrompt(true, response.data.not_fulfilled_items, 'out of stock'));
    dispatch(setNotFullFilledItems(response.data.not_fulfilled_items_list));
    dispatch(setLastCartInput(data.input))
    if (data.hasOwnProperty('store_order_id')) {
      navigate('ScanToCart');
    }
    if(callBack) callBack();
    return;
  }

  if (response.data?.message === 'Already printed') {
    dispatch(setPrompt(true, data.input, 'reprint'));
    dispatch(handleCartData(response.data.cart));
    dispatch(setMainInputFocus(false));
    dispatch(setMainInputFocus(true));
    if (data.hasOwnProperty('store_order_id')) {
       dispatch(setLastCartInput(data.input));
       return callBack(data.input, 'not empty cart');
    }
    if(callBack) callBack();
    return;
  }

  if (response.data?.message?.includes('Post scanning for order') || response.data?.message?.includes('Tote printed') || response.data?.message?.includes('Reprint for order')) {
    dispatch(handleCartData(response.data.cart));
    dispatch(setActiveTote(null))
    if (data.hasOwnProperty('store_order_id')) {
      navigate('ScanToCart');
    }
    if(callBack) callBack();
    dispatch(handleToteOrderCompletionAndNavigation(response.data.cart, data.original_input ?? data.input))
    return;
  }

  if (response.data?.message?.includes('Cart scanning completed')) {
    if(callBack) callBack();
    dispatch(setCurrentCartScanComplete(true));
    return;
  }

  if (response.data?.message?.includes('Cart is not picked yet') && response.data?.cart) {
    dispatch(handleCartData(response.data.cart));
    dispatch(handleIsEmptyCart(true));
    dispatch(setLastCartInput(data.input));
    return callBack(data.input, 'not empty cart');
  }

  if (response.data?.data?.has_pending_orders) {
    if(response.data.data.cart?.isPicked){
      dispatch(handleCartData(response.data.data.cart));
      const pendingReScanOrder = data.reset_item
        ? null
        : findPendingReScanOrder(response.data.data.cart, data.original_input ?? data.input);
      if (pendingReScanOrder && dispatch(resumePendingReScan(pendingReScanOrder))) {
        if(callBack) callBack();
        return;
      }
      dispatch(handleIsEmptyCart(true));
      dispatch(setLastCartInput(data.input));
      return callBack(data.input, 'not empty cart');
    }
    dispatch(handleIsEmptyCart(true));
    dispatch(setLastCartInput(data.input));
    return callBack(data.input, 'not empty cart');
  }

  const hasResetMessage = response.data.success_messages.some(message =>
    message.includes('has been reset successfully')
  );
  if (hasResetMessage) {
    return callBack(data.input, response.data.success_messages[0]);
  }

  if (response.data.status) {
    const assignedOrders = response.data.success_messages || [];
    const notAssignedOrders = response.data.error_messages || [];

    dispatch(setCartAssignmentDetails(notAssignedOrders, assignedOrders));
    dispatch(setCartAssignmentToast(true));
    const allAssignmentsFailed = notAssignedOrders.length > 0 && assignedOrders.length === 0;
    const rawCart = response.data?.data?.cart;
    const cartPayload = Array.isArray(rawCart) ? rawCart[0] : rawCart;
    if (cartPayload && !allAssignmentsFailed) {
      dispatch(handleCartData(cartPayload));
      if(callBack) callBack();
      navigate('ScanToCart');
      return;
    }

    if (
      response.data.error_messages.some(msg =>
        msg.includes('User already has a cart')
      )
    ) {
      const payload = {
        isInprogress: true,
        data: response.data.data.cart
      };
      dispatch(setPickingSession(payload));
      return;
    }
  }

  if (!response?.data?.data?.next_state) {
    callBack();
    return;
  }
}

export function ResetSearchOrderData() {
 return async dispatch => {
  dispatch({
    type: RESET_SCANPACK_ORDER
  });
 };
}


export function UpdateProduct(data) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    axios({
      method: 'post',
      url: `${url}/products/update_product_list.json?id=${data.id}&var=${data.name}&value=${data.value}`,
      headers: {Authorization: `Bearer ${access_token}`}
      // data: data
    })
      .then(data => {
        dispatch({
          type: UPDATE_PRODUCT,
          payload: data.data.data
        });
      })
      .catch(error => {
        // console.log("error2-->",error.response.status)
        dispatch({
          type: UPDATE_PRODUCT_FAIL,
          payload: error.response.status
        });
      });
  };
}


export function updateOfflineOrder(data) {
  return async dispatch => {
    dispatch({type : OFFLINE_DATA, payload : data })
  }
}

export function ImportOrder() {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    axios({
      method: 'get',
      url: `${url}/orders/import_all.json`,
      headers: {Authorization: `Bearer ${access_token}`}
      // data: data
    })
      .then(data => {
        // console.log("data import order---->",data.data)
        dispatch({
          type: IMPORT_ORDER_SUCCESS,
          payload: data.data
        });
        return dispatch(ImportOrderStatus());
      })
      .catch(error => {
        // console.log("error3-->",error.response.status)

        dispatch({
          type: IMPORT_ORDER_FAIL,
          payload: error.response.status
        });
      });
  };
}

export function ImportOrderStatus() {
  // console.log("----------status-------")
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    axios({
      method: 'get',
      url: `${url}/home/import_status`,
      headers: {Authorization: `Bearer ${access_token}`}
    })
      .then(data => {
        // console.log("data import order status---????????->",data.data)
        dispatch({
          type: IMPORT_ORDER_STATUS_SUCCESS,
          payload: data.data
        });
      })
      .catch(error => {
        // console.log("error4-->",error.response.status)

        // console.log("----------data import status error->",error)
        dispatch({
          type: IMPORT_ORDER_STATUS_FAIL,
          payload: error?.response?.status
        });
      });
  };
}

export function FullOrderScan(orderID) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    axios({
      method: 'post',
      url:`${url}/scan_pack/verify_order_scanning`,
      headers: {Authorization: `Bearer ${access_token}`},
      data:`id=${orderID}&app_url=${window.location.origin}`
    })
      .then(res => {
        console.log("check res",res);
        dispatch({
          type: FULL_ORDER_SCAN_CHECK,
        });
      })
      .catch(error => {
        console.error('FullOrderScan error:', error);
      });
  };
}

export function CallPostScanModule(moduleName, orderId, input = null, onEx = null, extra = null, callback = null) {
  return async dispatch => {
    try {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');
      const payload = {
        module: moduleName,
        order_id: orderId,
        input: input,
        on_ex: onEx
      };
      const finalPayload = extra ? { ...payload, ...extra } : payload;
      const response = await axios.post(`${url}/scan_pack/post_scan`, finalPayload, {
        headers: { Authorization: `Bearer ${access_token}` }
      });
      const data = response?.data;
      if (typeof callback === 'function') {
        try { callback(data); } catch (cbErr) { console.error('CallPostScanModule callback error:', cbErr); }
      }
      return data;
    } catch (error) {
      console.error('CallPostScanModule error:', moduleName, orderId, error);
      return null;
    }
  };
}

export function detectOrdersDiscrepancies(orders_data) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    axios({
      method: 'post',
      url:`${url}/scan_pack/detect_discrepancy`,
      headers: {Authorization: `Bearer ${access_token}`},
      data: {data: orders_data, app_url: window.location.origin}
    })
      .then(res => {
        dispatch({
          type: DETECT_ORDERS_DISCREPANCIES,
          payload: res?.data
        });
      })
      .catch(error => {
        console.log('error in discrepancy function => ', error);
      });
  };
}

export function SetDashboardData(data) {
  return dispatch => {
    dispatch({
      type: DASHBOARD_DATA,
      payload: data
    });
  };
}
export function CheckImportOrderProcess(storeId) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    axios({
      method: 'get',
      url: `${url}/order_import_summary/get_import_details?store_id=${storeId}`,
      headers: {Authorization: `Bearer ${access_token}`}
    })
      .then(async data => {
        const {
          total_imported,
          last_imported_data,
          import_start,
          import_end,
          elapsed_time,
          status
        } = data.data;

        const dataToStore = {
          imported_orders: total_imported,
          imported_date: last_imported_data,
          import_start,
          import_end,
          elapsed_time
        };
          await AsyncStorage.setItem('ImportStatus', status);
        for (const [key, value] of Object.entries(dataToStore)) {
          await AsyncStorage.setItem(key, JSON.stringify(value));
        }
        dispatch({
          type: CHECK_IMPORT_ORDER_STATUS_SUCCESS,
          payload: data.data
        });
      })
      .catch(error => {
        dispatch({
          type: CHECK_IMPORT_ORDER_STATUS_FAIL,
          payload: error?.response?.status
        });
      });
  };
}

export function hideDuplicatePickWarning() {
  return dispatch => {
    dispatch({
      type: HIDE_DUPLICATE_PICK_WARNING
    });
  };
}

export function hideDuplicatePickToast() {
  return dispatch => {
    dispatch({
      type: HIDE_DUPLICATE_PICK_TOAST
    });
  };
}

export function clearOnDemandImportEvent() {
  return dispatch => {
    dispatch({
      type: CLEAR_ON_DEMAND_IMPORT_EVENT
    });
  };
}
